/* ==========================================================================
   Dynoforce header
   USP-balk inklappen, mobiel menu, winkelwagenteller en de auto-finder.
   Voertuigdata komt uit window.DFData, zie df-data.js.
   ========================================================================== */

(function () {
  'use strict';

  var hdr = document.querySelector('.hdr');
  if (!hdr) return;

  /* ---------- USP-balk klapt in zodra je scrollt -------------------------
     Dit bestand laadt met defer en draait dus pas nadat de pagina al een keer
     getekend is. De balk staat op dat moment open, want de markup kent geen
     statusklasse. Zet je daarna 'scrolled' terwijl de transitie aanstaat, dan
     schuift hij zichtbaar dicht terwijl de bezoeker niets gedaan heeft.

     Bij het heropenen van een tabblad is dat het ergst: de browser zet een
     herstelde scrollpositie pas rond het load-event terug, dus op het moment
     dat dit script draait is scrollY nog nul en klopt de eerste meting niet.
     Vandaar twee dingen: opnieuw meten op de momenten waarop de browser die
     positie kan terugzetten, en de animatie pas aanzetten bij het eerste echte
     gebaar. Tot dat moment landt de balk in een keer in de goede stand.      */
  function onScroll() {
    hdr.classList.toggle('scrolled', window.scrollY > 40);
  }
  addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  addEventListener('load', onScroll);
  addEventListener('pageshow', onScroll);

  function animatieAan() { hdr.classList.add('hdr--anim'); }
  ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (t) {
    addEventListener(t, animatieAan, { once: true, passive: true });
  });

  /* ---------- Dichte navbalk op pagina's zonder donkere kop ---------------
     De doorzichtige balk is gemaakt voor pagina's die met een donkere hero
     beginnen. Op de winkelwagen, zoekresultaten of een 404 staat hij op een
     lichte achtergrond en wordt hij grauw. Daar krijgt hij een dichte kleur. */
  function bepaalNavKleur() {
    var main = document.querySelector('main') || document.body;
    var sec = main.querySelector('.shopify-section');
    var kandidaten = [];
    if (sec) {
      kandidaten.push(sec);
      /* De sectie begint met een style-blok, dus zoek het eerste echte vlak
         met hoogte. Coordinaten gebruiken kan niet: in een verborgen venster
         is innerWidth nul en levert elementsFromPoint niets op. */
      var alle = sec.querySelectorAll('*');
      for (var n = 0; n < alle.length && kandidaten.length < 14; n++) {
        var tag = alle[n].tagName;
        if (tag === 'STYLE' || tag === 'SCRIPT' || tag === 'LINK' || tag === 'TEMPLATE' || tag === 'NOSCRIPT') continue;
        if (alle[n].getBoundingClientRect().height < 80) continue;
        kandidaten.push(alle[n]);
      }
    }
    kandidaten.push(document.body);
    for (var i = 0; i < kandidaten.length; i++) {
      var bg = getComputedStyle(kandidaten[i]).backgroundColor;
      if (!bg || bg === 'transparent' || bg.replace(/\s/g, '') === 'rgba(0,0,0,0)') continue;
      var d = bg.match(/\d+(\.\d+)?/g);
      if (!d || d.length < 3) continue;
      var helderheid = 0.299 * +d[0] + 0.587 * +d[1] + 0.114 * +d[2];
      hdr.classList.toggle('hdr--vast', helderheid > 140);
      return;
    }
  }
  /* Meerdere meetmomenten: vlak na het laden staat de opmaak nog niet vast. */
  [0, 200, 600, 1200].forEach(function (ms) { setTimeout(bepaalNavKleur, ms); });
  addEventListener('load', bepaalNavKleur);
  document.addEventListener('shopify:section:load', bepaalNavKleur);

  /* ---------- Roterende boodschappen in de rode balk ----------------------
     Elke zes seconden de volgende boodschap, zoals de oude
     aankondigingsbalk. Bij reduced motion blijft de eerste staan.          */
  var msgWrap = hdr.querySelector('[data-df-top-msgs]');
  if (msgWrap) {
    var msgs = msgWrap.querySelectorAll('.df-top__msg');
    if (msgs.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var actief = 0;
      setInterval(function () {
        msgs[actief].classList.remove('on');
        actief = (actief + 1) % msgs.length;
        msgs[actief].classList.add('on');
      }, 6000);
    }
  }

  /* ---------- Zoeken -----------------------------------------------------
     Klapt open onder de navbalk en zet de aandacht meteen in het veld. Sluit
     het mobiele menu en de finder, want die delen dezelfde ruimte.          */
  var zoekTog = hdr.querySelector('.df-zoek__tog');
  var zoekPaneel = hdr.querySelector('.df-zoek');
  if (zoekTog && zoekPaneel) {
    zoekTog.addEventListener('click', function () {
      var open = hdr.classList.toggle('zoekopen');
      zoekTog.setAttribute('aria-expanded', String(open));
      if (open) {
        hdr.classList.remove('open', 'fopen');
        var veld = zoekPaneel.querySelector('input[name="q"]');
        if (veld) veld.focus();
      } else {
        var bak = zoekPaneel.querySelector('[data-df-zoek-uit]');
        if (bak) bak.hidden = true;
      }
    });
  }

  /* ---------- Live zoekresultaten ----------------------------------------
     Suggesties uit Shopify's eigen voorspellende zoekopdracht. We bouwen de
     rijen met losse knopen en nooit met innerHTML: titels en prijzen komen uit
     de winkel en horen geen opmaak mee te kunnen brengen.                   */
  /* Sinds 1-10-2026 niet alleen in de menubalk: elk blok met data-df-zoekvorm
     (een veld name="q" plus een [data-df-zoek-uit]) krijgt dezelfde live
     suggesties, zoals het zoekveld in de shopkop. */
  function bindZoek(zoekVeld, zoekUit, opPagina) {
    var wachten = null;
    var laatsteVraag = '';
    var basis = (window.routes && window.routes.predictive_search_url) || '/search/suggest';

    function leeg() { while (zoekUit.firstChild) zoekUit.removeChild(zoekUit.firstChild); }

    /* De suggestie-API geeft de prijs als kaal getal terug, bijvoorbeeld
       "1316.00". Hier maken we er een Nederlands bedrag van: punt als
       duizendtal, komma als decimaal. */
    function bedrag(ruw) {
      var n = parseFloat(String(ruw).replace(',', '.'));
      if (isNaN(n)) return String(ruw);
      var heel = Math.floor(n);
      var cent = Math.round((n - heel) * 100);
      var m = String(heel).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return '\u20AC ' + m + ',' + (cent < 10 ? '0' + cent : cent);
    }

    function regel(item) {
      var a = document.createElement('a');
      a.className = 'df-zoek__rij';
      a.href = item.url;
      a.setAttribute('role', 'option');
      if (item.featured_image && item.featured_image.url) {
        var img = document.createElement('img');
        img.className = 'df-zoek__mini';
        img.src = item.featured_image.url;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 44; img.height = 44;
        a.appendChild(img);
      }
      var tx = document.createElement('div');
      tx.className = 'df-zoek__tx';
      var b = document.createElement('b');
      b.textContent = item.title;
      tx.appendChild(b);
      if (item.vendor) {
        var sp = document.createElement('span');
        sp.textContent = item.vendor;
        tx.appendChild(sp);
      }
      a.appendChild(tx);
      if (item.price) {
        var pr = document.createElement('div');
        pr.className = 'df-zoek__prijs';
        pr.textContent = bedrag(item.price);
        a.appendChild(pr);
      }
      return a;
    }

    function toon(data, q) {
      leeg();
      var bron = (data && data.resources && data.resources.results) || {};
      var producten = bron.products || [];
      var paginas = (bron.pages || []).concat(bron.articles || []);

      /* Eerst de auto, als de zoekterm er een bevat (df-zoekauto.js). Daarna
         pas de producten van Shopify; zonder auto blijft alles zoals het was. */
      var autoBlok = window.DFZoekAuto ? window.DFZoekAuto.blok(q) : null;
      if (autoBlok) zoekUit.appendChild(autoBlok);

      if (!producten.length && !paginas.length) {
        if (!autoBlok) {
          var niks = document.createElement('div');
          niks.className = 'df-zoek__niks';
          niks.textContent = 'Niets gevonden. Probeer een merk, een onderdeel of je kenteken.';
          zoekUit.appendChild(niks);
        }
        zoekUit.hidden = false;
        return;
      }
      if (autoBlok) zoekUit.appendChild(window.DFZoekAuto.tussenkop());
      producten.slice(0, 6).forEach(function (p) { zoekUit.appendChild(regel(p)); });
      paginas.slice(0, 3).forEach(function (p) { zoekUit.appendChild(regel(p)); });

      var meer = document.createElement('a');
      meer.className = 'df-zoek__meer';
      meer.href = ((window.routes && window.routes.search_url) || '/search') + '?q=' + encodeURIComponent(q);
      meer.textContent = 'Alle resultaten voor "' + q + '"';
      zoekUit.appendChild(meer);
      zoekUit.hidden = false;
    }

    zoekVeld.addEventListener('input', function () {
      var q = zoekVeld.value.trim();
      clearTimeout(wachten);
      if (q.length < 2) { leeg(); zoekUit.hidden = true; return; }
      /* De auto meteen tonen; die lijst staat al op de pagina, daar hoeft
         niets voor opgehaald te worden. */
      if (window.DFZoekAuto) window.DFZoekAuto.ververs(zoekUit, q);
      /* Even wachten met typen, anders vuren we bij elke aanslag een verzoek af. */
      wachten = setTimeout(function () {
        if (q === laatsteVraag) return;
        laatsteVraag = q;
        fetch(basis + '.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product,page,article&resources[limit]=6' +
              '&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku', {
          headers: { Accept: 'application/json' }
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) { if (d && zoekVeld.value.trim() === q) toon(d, q); })
          .catch(function () { /* stil: het formulier werkt nog gewoon */ });
      }, 220);
    });

    /* Op een pagina is er geen paneel dat dichtklapt, dus daar sluit het
       menu bij Escape, bij een klik ernaast, en komt het terug zodra het
       veld weer de aandacht krijgt. */
    if (opPagina) {
      var wrap = zoekUit.parentNode;
      var terug = function () {
        if (zoekVeld.value.trim().length >= 2 && zoekUit.firstChild) zoekUit.hidden = false;
      };
      zoekVeld.addEventListener('focus', terug);
      zoekVeld.addEventListener('click', terug);
      zoekVeld.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') zoekUit.hidden = true;
      });
      document.addEventListener('click', function (e) {
        if (wrap && !wrap.contains(e.target)) zoekUit.hidden = true;
      });
    }
  }

  var zoekUit = hdr.querySelector('[data-df-zoek-uit]');
  var zoekVeld = hdr.querySelector('.df-zoek__veld');
  if (zoekUit && zoekVeld) bindZoek(zoekVeld, zoekUit, false);
  Array.prototype.forEach.call(document.querySelectorAll('[data-df-zoekvorm]'), function (wrap) {
    var veld = wrap.querySelector('input[name="q"]');
    var uit = wrap.querySelector('[data-df-zoek-uit]');
    if (veld && uit && !hdr.contains(wrap)) bindZoek(veld, uit, true);
  });

  /* ---------- Mobiel menu ------------------------------------------------ */
  var mnu = hdr.querySelector('.mnu');
  if (mnu) {
    mnu.addEventListener('click', function () {
      var open = hdr.classList.toggle('open');
      mnu.setAttribute('aria-expanded', String(open));
      if (open) hdr.classList.remove('fopen');
    });
    hdr.querySelectorAll('.lnk a:not(.ftog)').forEach(function (a) {
      a.addEventListener('click', function () {
        hdr.classList.remove('open');
        mnu.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* Escape sluit menu en finder. */
  addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    hdr.classList.remove('open', 'fopen', 'zoekopen');
    if (mnu) mnu.setAttribute('aria-expanded', 'false');
    if (zoekTog) zoekTog.setAttribute('aria-expanded', 'false');
    var t = hdr.querySelector('.ftog');
    if (t) t.setAttribute('aria-expanded', 'false');
  });

  /* ---------- Winkelwagenteller -----------------------------------------
     Dawn stuurt na elke wijziging een cart-update via pubsub. We lezen het
     aantal daaruit en vallen terug op /cart.js als het veld ontbreekt.    */
  var counters = document.querySelectorAll('[data-df-cart-count]');

  function setCount(n) {
    counters.forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = n === 0;
      var link = el.closest('.df-cart');
      if (link) {
        link.setAttribute('aria-label', n === 0
          ? 'Winkelmand, leeg'
          : 'Winkelmand, ' + n + (n === 1 ? ' artikel' : ' artikelen'));
      }
    });
  }

  function refreshFromApi() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); })
      .catch(function () { /* teller blijft staan zoals hij stond */ });
  }

  if (counters.length && typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
      var count = event && event.cartData && event.cartData.item_count;
      if (typeof count === 'number') setCount(count);
      else refreshFromApi();
    });
  }

  /* Dawn en Ignite verversen na elke cart-wijziging de sectie
     cart-icon-bubble in #cart-icon-bubble; dat is bij ons een verborgen span
     in het winkelwagen-anker. Meekijken op die swap werkt in beide thema's,
     ook als hun pubsub niet als globale functie bestaat.                    */
  var bubbleSink = document.getElementById('cart-icon-bubble');
  if (counters.length && bubbleSink && 'MutationObserver' in window) {
    new MutationObserver(function () {
      var b = bubbleSink.querySelector('.cart-count-bubble span[aria-hidden]');
      var n = b ? parseInt(b.textContent, 10) : NaN;
      if (!isNaN(n)) setCount(n);
      else refreshFromApi();
    }).observe(bubbleSink, { childList: true, subtree: true });
  }

  /* Naar buiten, zodat andere secties de teller kunnen bijwerken zonder hun
     eigen halve versie te schrijven. setCount regelt ook het hidden-attribuut
     en het aria-label - juist dat ging elders mis.

     Dit is niet voor de sier. De pubsub-abonnee hierboven vuurt namelijk
     nooit: assets/constants.js declareert PUB_SUB_EVENTS als top-level const
     in een classic script, en zo'n const komt niet op window terecht. De
     voorwaarde is dus altijd onwaar. Deze haak is de werkende vervanging. */
  window.DFCart = {
    setCount: setCount,
    ververs: refreshFromApi
  };

  /* ---------- Auto-finder ------------------------------------------------ */
  var ftog = hdr.querySelector('.ftog');
  var panel = hdr.querySelector('.finder');
  if (!ftog || !panel) return;

  var sMerk = panel.querySelector('[data-f="merk"]');
  var sModel = panel.querySelector('[data-f="model"]');
  var sGen = panel.querySelector('[data-f="gen"]');
  var sMot = panel.querySelector('[data-f="mot"]');
  var go = panel.querySelector('[data-f="go"]');
  var msg = panel.querySelector('.fmsg');
  var tree = null;

  function placeholder(sel, label) {
    sel.innerHTML = '<option value="">' + label + '</option>';
    sel.disabled = true;
  }
  function fill(sel, items, label) {
    sel.innerHTML = '<option value="">' + label + '</option>' +
      items.map(function (i) {
        return '<option value="' + escapeAttr(i) + '">' + escapeHtml(i) + '</option>';
      }).join('');
    sel.disabled = false;
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }

  function resetFrom(level) {
    if (level <= 2) placeholder(sModel, sModel.dataset.label);
    if (level <= 3) placeholder(sGen, sGen.dataset.label);
    if (level <= 4) placeholder(sMot, sMot.dataset.label);
    go.disabled = true;
  }

  ftog.addEventListener('click', function (e) {
    e.preventDefault();
    var open = hdr.classList.toggle('fopen');
    ftog.setAttribute('aria-expanded', String(open));
    if (open) {
      hdr.classList.remove('open');
      loadTree();
      sMerk.focus();
    }
  });

  var loading = false;
  function loadTree() {
    if (tree || loading) return;
    loading = true;
    window.DFData.getVehicleTree().then(function (data) {
      tree = data;
      fill(sMerk, Object.keys(tree), sMerk.dataset.label);
      loading = false;
    }).catch(function (err) {
      loading = false;
      if (msg) msg.textContent = err.message;
    });
  }

  sMerk.addEventListener('change', function () {
    resetFrom(2);
    if (sMerk.value && tree[sMerk.value]) fill(sModel, Object.keys(tree[sMerk.value]), sModel.dataset.label);
  });
  sModel.addEventListener('change', function () {
    resetFrom(3);
    if (sModel.value) fill(sGen, Object.keys(tree[sMerk.value][sModel.value]), sGen.dataset.label);
  });
  sGen.addEventListener('change', function () {
    resetFrom(4);
    if (sGen.value) fill(sMot, tree[sMerk.value][sModel.value][sGen.value], sMot.dataset.label);
  });
  sMot.addEventListener('change', function () { go.disabled = !sMot.value; });

  go.addEventListener('click', function () {
    if (go.disabled) return;
    var params = new URLSearchParams({
      merk: sMerk.value,
      auto: sMerk.value + ' ' + sModel.value + ', ' + sGen.value + ', ' + sMot.value
    });
    location.href = go.dataset.target + '?' + params.toString();
  });
})();
